import { getIcon } from "../../../../../../../../../utils/get-icon";
import { useSettings } from "../../../../../context";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  AccordionTitle,
  InnerAccordionHeader,
} from "../styled";
import {
  DoubleCol,
  SizeInput,
  SizeInputIcon,
  SizeInputWrapper,
} from "./styled";

const SizeSettings = () => {
  const { updateSizeSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (!currentSettings || !("size" in currentSettings)) {
    return null;
  }

  const handleWidthChange = (e: any) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value)) {
      updateSizeSettings({ width: value });
    }
  };

  const handleHeightChange = (e: any) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      updateSizeSettings({ height: value });
    }
  };

  return (
    <AccordionItem key="2" eventKey="2">
      <AccordionHeader>
        <InnerAccordionHeader>
          <AccordionTitle>{getIcon("")} Størrelse</AccordionTitle>
        </InnerAccordionHeader>
      </AccordionHeader>
      <AccordionBody>
        <DoubleCol>
          <SizeInputWrapper>
            <SizeInputIcon>{getIcon("text-width")}</SizeInputIcon>
            <SizeInput
              onChange={handleWidthChange}
              value={currentSettings.size?.width}
              type="number"
            />
          </SizeInputWrapper>
          <SizeInputWrapper>
            <SizeInputIcon>{getIcon("text-height")}</SizeInputIcon>
            <SizeInput
              onChange={handleHeightChange}
              value={currentSettings.size?.height}
              type="number"
            />
          </SizeInputWrapper>
        </DoubleCol>
      </AccordionBody>
    </AccordionItem>
  );
};

export default SizeSettings;
